import http from '../_http'

const system = {
  //default
  summarySys: (m) => { return http.get(`manager/wmds/system`, m); },
  listSys: (m) => { return http.post(`manager/wmds/system/list`, m); },
  detailSys: (m) => { return http.get(`manager/wmds/system/${m.id}`); },

  //crud
  insertSys: (m) => { return http.post(`manager/wmds/system`, m); },
  updateSys: (m) => { return http.put(`manager/wmds/system`, m); },
  deleteSys: (m) => { return http.delete(`manager/wmds/system/${m.id}`); },
}

export default system

export { system }